<pos-app-spinner [show]="loading$ | async"></pos-app-spinner>
<div class="text-center">
  <h3 class="arb-large-heading">MY RECENT ORDERS</h3>
</div>
<div>
  <div class="col pt-2 mx-4">
    <label>PARKED ORDERS:</label>

    <ag-grid-angular
      #agGrid
      class="ag-theme-balham datagrid"
      [rowData]="parkedOrderList"
      [context]="context"
      [frameworkComponents]="frameworkComponents"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="10"
    >
    </ag-grid-angular>
  </div>
</div>
